'use strict';

const PlayerShot = require('../entities/player-shot');

class PlayerShotPool {
  constructor(capacity) {
    this.capacity = capacity || 80;
    this.limit = Math.min(48, this.capacity);
    this.items = Array.from({ length: this.capacity }, () => new PlayerShot());
  }

  activeCount() {
    return this.items.reduce((count, shot) => count + (shot.active ? 1 : 0), 0);
  }

  spawn(options) {
    if (this.activeCount() >= this.limit) return null;
    const shot = this.items.find((item) => !item.active);
    return shot ? shot.reset(options) : null;
  }

  update(dt, bounds) {
    this.items.forEach((shot) => shot.update(dt, bounds));
  }

  draw(ctx) {
    this.items.forEach((shot) => shot.draw(ctx));
  }

  getActive() {
    return this.items.filter((shot) => shot.active);
  }

  clear() {
    this.items.forEach((shot) => { shot.active = false; });
  }
}

module.exports = PlayerShotPool;
